module.exports = __webpack_public_path__ + "img/about_us_banner.2694365a.gif";